import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { type IChosenInsuredProgram } from '@/app/types/dmsTypes'
import { onRenderMarkdown } from '@/app/utils'
import { BlurApp } from '@/shared'

import { Attached } from './Attached/Attached'
import style from './CurrentProgram.module.scss'
import { DatesRangesProgramModal } from './DatesRangesProgramModal/DatesRangesProgramModal'
import { InsuredSpecialConditions } from './InsuredSpecialConditions/InsuredSpecialConditions'

interface IProps extends IChosenInsuredProgram {
    contractId: string
}

export const CurrentProgram = observer((props: IProps) => {
    const { id, contractId, name, descriptions, dateRanges, specialConditions, programActualMode } = props

    const [showDescription, setShowDescription] = useState<boolean>(false)
    const [showRanges, setShowRanges] = useState<boolean>(false)

    const { insuredId } = useParams()

    if (!insuredId) {
        return null
    }

    const onShowMoreDetails = () => setShowDescription((prev) => !prev)

    const detailsBtn = showDescription ? 'Закрыть' : 'Подробнее'

    const datesBtn = dateRanges.length > 0 ? 'См. даты прикрепления' : 'Прикрепить'

    const onDatesRangesClickHandler = () => {
        setShowRanges(true)
    }

    return (
        <div className={classNames(style.container, showDescription && style.containerBlured)}>
            {showRanges && (
                <DatesRangesProgramModal
                    ranges={dateRanges}
                    onClose={() => setShowRanges(false)}
                    contractId={contractId}
                    programId={id}
                    polisId={insuredId}
                />
            )}
            <BlurApp show={showDescription} withScroll />
            <div className={style.mainContentWrapper}>
                <Attached programActualMode={programActualMode} />
                <div className={style.nameAndDatesWrapper}>
                    <div>
                        <span>{name}</span>
                    </div>
                </div>
                <div className={style.detailsBtn}>
                    {!showDescription && (
                        <div className={style.dateWrapper} onClick={onDatesRangesClickHandler}>
                            <span>{datesBtn}</span>
                        </div>
                    )}
                    <div onClick={onShowMoreDetails}>
                        <span>{detailsBtn}</span>
                    </div>
                </div>
            </div>
            {showDescription && (
                <div className={style.descriptionWrapper}>
                    <span dangerouslySetInnerHTML={{ __html: onRenderMarkdown(descriptions) }}></span>
                </div>
            )}
            {!showDescription && (
                <InsuredSpecialConditions
                    showDescription={showDescription}
                    specialConditions={specialConditions}
                    polisId={insuredId}
                    insuranceProgramId={id}
                />
            )}
        </div>
    )
})
